import { defineStore } from 'pinia'
import Cookies from "js-cookie";

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: Cookies.get("auth") as string | null,
    }),

    actions: {
        login(token: string) {
            this.token = token
            Cookies.set("auth", token, { expires: 14 });
        },
        logout() {
            const userStore = useUserStore();
            const workspaceStore = useWorkspaceStore();
            const conversationStore = useConversationStore();

            // clear the user
            userStore.clear();

            // clear the workspace
            workspaceStore.clear();

            // clear the conversation
            conversationStore.clear();

            this.token = null
            Cookies.remove("auth");
        }
    }
})